export enum EditStatus {
  edit = 'edit',
  confirm = 'confirm',
  decline = 'decline',
  delete = 'delete',

  newModel = 'newModel',
  copyModel = 'copyModel',
  renameModel = 'renameModel',
  startRename = 'startRename',

  addGroup = 'addGroup',
  duplicateGroup = 'duplicateGroup',
  updateGroupName = 'updateGroupName',
  deleteGroup = 'deleteGroup',

  updateSubGroupName = 'updateSubGroupName',
  addSubGroup = 'addSubGroup',
  updateSubGroup = 'updateSubGroup',
  updateSubGroupOrder = 'updateSubGroupOrder',
  updateGroupOrder = 'updateGroupOrder',
  deleteSubGroup = 'deleteSubGroup',
  duplicateSubGroup = 'duplicateSubGroup',
}

export enum TotalControlNames {
  writeOff = 'writeOff',
  exitCompNumber = 'exitCompNumber',
  investment = 'investment',
  exitProceeds = 'exitProceeds',
  moic = 'moic',
  gain = 'gain',
  round = 'round'
}

export enum FundStrategyMetricsNames {
  totalCommitment = 'totalCommitment',
  unAllocatedCommitment = 'unAllocatedCommitment',
  expectedExpenses = 'expectedExpenses',
  expectedExpensesPcnt = 'expectedExpensesPcnt',
  carryInterest = 'carryInterest',
  carryInterestPcnt = 'carryInterestPcnt',
  netGainAfterCarry = 'netGainAfterCarry',
  tvpi = 'tvpi',
  gain = 'gain',
}
